import { Subscription } from "rxjs";
import { AuthService } from "../auth/service/auth.service";
import { Directive, Input, OnDestroy, TemplateRef, ViewContainerRef } from "@angular/core";

@Directive({
  selector: "[appHasRole]",
  standalone: false,
})
export class HasRoleDirective implements OnDestroy {
  private userRole!: string;
  private subscription: Subscription;

  constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef, private authService: AuthService) {
    this.subscription = this.authService.getUserRole().subscribe((role) => {
      this.userRole = role;
      this.updateView();
    });
  }

  @Input()
  set appHasRole(roles: string[] | undefined) {
    this.roles = roles;
    this.updateView();
  }

  get appHasRole(): string[] | undefined {
    return this.roles;
  }

  private roles: string[] | undefined;

  private updateView() {
    if (!this.roles || this.roles.length === 0 || this.roles.includes(this.userRole)) {
      if (this.viewContainer.length === 0) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
    }
    else {
      this.viewContainer.clear();
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
